module.exports = __webpack_public_path__ + "img/halloween.d8b8a74a.jpg";